@if (initialized) {
  @if (isPartner && step === 'nfr') {
    <app-nfr-one-prepare
      (selected)="onNfrOnePrepareSelected()"
      (back)="onNfrOnePrepareBack()"
      [isWorkflow]="true"
    ></app-nfr-one-prepare>
  }
  @if (step === 'trial-phonenumber') {
    <app-order-trial-phonenumber
      (selected)="onTrialPhonenumberSelected($event)"
      (backEmitter)="onTrialPhonenumberBack()"
      [historyBack]="false"
    ></app-order-trial-phonenumber>
  }
  @if (step === 'instance') {
    <app-select-instance-name
      (selected)="onInstanceNameSelected($event)"
      (backEmitter)="onSelectInstanceNameBack()"
      [isTrial]="true"
      selectedDomain=""
    ></app-select-instance-name>
  }
  @if (step === 'phonenumber') {
    <app-phonenumber
      (selected)="onPhonenumberSelected($event)"
      [hideBackButton]="true"
    ></app-phonenumber>
  }
}
